/**
TODO replace with AppRoutes
 **/
export enum NavigableRoutes {
	LinkedAccounts = "/account/linked-accounts",
	VendorAccounts = "/account/vendor-accounts",
	DisplayPreferences = "/account/display-preferences",
	EndOfRegistration = "/account/end-of-registration",
	Login = "/account/sign-in",
	Profile = "/account/my-profile",
	AccountDataProfile = "/account/my-profile/company-info",
	DisplayPreferencesProfile = "/account/my-profile/display-preferences",
	LinkedAccountsProfile = "/account/my-profile/linked-accounts",
	TransferAccountProfile = "/account/my-profile/transfer-account",
	ResetPasswordProfile = "/account/my-profile/reset-password",
	Base = "/",
	RegisterCredentials = "/account/register",
	AccountData = "/account/account-data",
	EmailInputForgotPassword = "/account/forgot-password-request",
	Error = "/error",
	NotFound = "/not-found",
	ManageItems = "/manage-items",
	RegistrationLinkALreadyUsed = "/register-link-used",
	AdminDashboard = "/admin/administration",
	SupplierInfo = "/admin/administration/supplier-info",
	VendorInfo = "/admin/administration/vendor-info",
	TransferAccount = "/admin/administration/transfer-account",
	SendInvitations = "/admin/administration/send-invitation",
	ResetPassword = "/admin/administration/reset-password",
	UserManagement = "/admin/administration/user-management",
	AdminRegistration = "/admin/admin-registration",
}

export default NavigableRoutes;
